import * as React from "react";
import classnames from "classnames";
import { Heading, Text } from "@grandvisionhq/elements";
/* empty css                  */
const NearbyStores = ({
  id = "nearby-stores",
  className,
  labels,
  stores,
  links
}) => /* @__PURE__ */ React.createElement(
  "section",
  {
    id,
    className: classnames("nearby-stores", className),
    "aria-labelledby": `${id}-title`
  },
  /* @__PURE__ */ React.createElement(Heading, { id: `${id}-title`, variant: "smallest", component: "h2" }, labels.title),
  /* @__PURE__ */ React.createElement("div", { className: "nearby-stores__group" }, stores.map(({ globalStoreId, url, image, label, distance }) => /* @__PURE__ */ React.createElement("a", { className: "nearby-stores__group-item", key: globalStoreId, href: url }, /* @__PURE__ */ React.createElement(
    "img",
    {
      className: "nearby-stores__group-item-thumbnail",
      loading: "lazy",
      src: image,
      alt: label
    }
  ), /* @__PURE__ */ React.createElement(Text, { className: "nearby-stores__group-item-label", variant: "body-head" }, label), /* @__PURE__ */ React.createElement(Text, { className: "nearby-stores__group-item-distance", variant: "body" }, distance)))),
  /* @__PURE__ */ React.createElement("div", { className: "nearby-stores__links" }, links.map(({ label, url }) => /* @__PURE__ */ React.createElement("a", { key: url, href: url }, label)))
);
export {
  NearbyStores,
  NearbyStores as default
};
//# sourceMappingURL=NearbyStores.js.map
